import * as React from 'react';
import styled from 'styled-components';

import { Divider } from 'src/styledComponents/Divider';

export const StyledDivider = styled(Divider)`
  background: ${(props) => props.theme.main.colors.clay4};
  margin: 8px 0;
`;
